import { render, staticRenderFns } from "./pape_doRecite.vue?vue&type=template&id=7647d808&scoped=true&"
import script from "./pape_doRecite.vue?vue&type=script&lang=js&"
export * from "./pape_doRecite.vue?vue&type=script&lang=js&"
import style0 from "./pape_doRecite.vue?vue&type=style&index=0&id=7647d808&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7647d808",
  null
  
)

export default component.exports